<template>
  <el-dialog
      :visible.sync="visible"
      title="合同复制"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="500px"
  >

    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="新合同编号：" prop="newOrderCode">
        <el-input
            v-model="dataForm.newOrderCode"
            placeholder="请输入新合同编号"
            clearable
            size="mini"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="30px">
        <el-checkbox v-model="dataForm.isPurchase">复制采购合同</el-checkbox>
        <el-checkbox v-model="dataForm.isMake">复制加工合同</el-checkbox>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'copy-dialog',
  data () {
    return {
      visible: false,
      dataForm: {
        newOrderCode: '',
        isPurchase: true,
        isMake: true,
        orderId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        newOrderCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init (orderId) {
      this.dataForm = {
        newOrderCode: '',
        isPurchase: true,
        isMake: true,
        orderId: orderId
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    cancel () {
      this.visible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm
        }
        this.$http.post('/trade/order/copy', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$emit('refreshDataList')
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
  }
}
</script>

<style scoped>

</style>
